import { get } from "lodash";
import { DisplayCurrency, PrecisionConfig, PrecisionType } from "@shared/types";

const getExchangeCoinPrecisionConfig = (
  precisionConfig?: PrecisionConfig | {},
  exchange?: string,
  coin?: string
) => {
  if (!exchange || !coin) return;
  return get(precisionConfig, ["exchanges", exchange, coin]);
};

const getCoinPrecisionConfig = (
  precisionConfig?: PrecisionConfig | {},
  coin?: string
) => {
  if (!coin) return;
  return get(precisionConfig, ["coins", coin]);
};

const getDefaultPrecision = (precisionConfig?: PrecisionConfig | {}) => {
  return get(precisionConfig, "default");
};

export const getPrecision = (
  precisionConfig?: PrecisionConfig | {},
  precisionType?: PrecisionType,
  displayCurrency?: DisplayCurrency,
  coin?: string,
  exchange?: string
) => {
  let precisionConfigs = [
    getExchangeCoinPrecisionConfig(precisionConfig, exchange, coin),
    getCoinPrecisionConfig(precisionConfig, coin),
    precisionConfig,
  ];

  let precision: any = null;
  precisionConfigs
    .filter((_precisionConfig) => !!_precisionConfig)
    .some((_precisionConfig) => {
      precision = precisionType ? _precisionConfig[precisionType] : undefined;
      if (typeof precision === "object" && displayCurrency) {
        precision = precision[displayCurrency];
      }
      return !!precision;
    });

  if (isNaN(precision)) {
    precision = getDefaultPrecision(precisionConfig);
  }

  return isNaN(precision) ? 0 : precision;
};
